import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { ChillBoids } from '../components/examples/boids';
export const _frontmatter = {
  "Title": "what is React-Sim?"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`React-sim is a framework for building and rendering simulations using React.`}</p>
    <ChillBoids mdxType="ChillBoids" />
    <p><a parentName="p" {...{
        "href": "/react-sim/examples/boids"
      }}>{`Boids example`}</a></p>
    <p>{`Simulations may have:`}</p>
    <ul>
      <li parentName="ul">{`a data model, with rules to initialize it and update it,`}</li>
      <li parentName="ul">{`a way to render them visually,`}</li>
      <li parentName="ul">{`logic to animate the model over time,`}</li>
      <li parentName="ul">{`a UI to let a user control it.`}</li>
    </ul>
    <p><inlineCode parentName="p">{`react-sim`}</inlineCode>{` lets developers work on all of these things separately and provides building blocks to get the common tasks out of the way.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      